'use client'
import { forwardRef, type ComponentProps, type ElementRef } from "react"
import * as PopoverPrimitives from "@radix-ui/react-popover"
import { cx } from "@/lib/utils"

const CalendarPopover = forwardRef<
    ElementRef<typeof PopoverPrimitives.Content>,
    ComponentProps<typeof PopoverPrimitives.Content> & { zIndex?: number }
>(({ align, className, children, zIndex, ...props }, forwardedRef) => {
    return (
        <PopoverPrimitives.Portal >
            <>
                <PopoverPrimitives.Close asChild>
                    <button
                        type="button"
                        aria-label="Close date picker"
                        tabIndex={-1}
                        className="fixed inset-0 z-10000 bg-black/10"
                    />
                </PopoverPrimitives.Close>
                <PopoverPrimitives.Content
                    ref={forwardedRef}
                    sideOffset={10}
                    side="bottom"
                    align={align}
                    avoidCollisions
                    onOpenAutoFocus={(e) => e.preventDefault()}
                    className={cx(
                        // base
                        "relative z-10001 w-fit rounded-md border text-sm shadow-xl shadow-black/[2.5%] font-roboto",
                        // widths
                        "max-w-[95vw] min-w-[calc(var(--radix-select-trigger-width)-2px)]",
                        // border color
                        "border-gray-200",
                        // background color
                        "bg-white",
                        // transition
                        "will-change-[transform,opacity]",
                        "data-[state=closed]:animate-hide",
                        "data-[state=open]:data-[side=bottom]:animate-slide-down-and-fade data-[state=open]:data-[side=left]:animate-slide-left-and-fade data-[state=open]:data-[side=right]:animate-slide-right-and-fade data-[state=open]:data-[side=top]:animate-slide-up-and-fade",
                        className,
                    )}
                    {...props}
                >
                    {children}
                </PopoverPrimitives.Content>
            </>
        </PopoverPrimitives.Portal>
    )
})

CalendarPopover.displayName = "DatePicker.CalendarPopover"

export { CalendarPopover }
